import {PaymentMethod} from '@stripe/stripe-js';

interface StripeFields {
  paymentMethod: string | null | PaymentMethod;
  stripeCustomerId: string;
}

export enum ActionTypes {
  GET_PAYMENT_METHODS = '[Billing] GetPaymentMethods',
  ADD_PAYMENT_METHOD = '[Billing] AddPaymentMethod',
  ADD_PAYMENT_METHOD_ONE_TIME = '[Billing] AddPaymentMethodOneTime',
  SET_PAYMENT_METHOD = '[Billing] SetPaymentMethod',
  DELETE_PAYMENT_METHOD = '[Billing] DeletePaymentMethod',
  GET_PAYMENT_INTENT = '[Billing] GetPaymentIntent',
  GET_STRIPE_BILLING = '[Billing] GetStripeBilling',
  GET_INVOICES = '[Billing] GetInvoices',
  PAY_INVOICE = '[Billing] PayInvoice',
  DELETE_INVOICE = '[Billing] DeleteInvoice',
  DELETE_INVOICE_ITEM = '[Billing] DeleteInvoiceItem'
}

export class AddPaymentMethod {
  static readonly type = ActionTypes.ADD_PAYMENT_METHOD;

  constructor(public payload: StripeFields & { setAsDefaultCard: boolean }) {
  }
}

export class AddPaymentMethodOneTime {
  static readonly type = ActionTypes.ADD_PAYMENT_METHOD_ONE_TIME;

  constructor(public payload: { paymentMethodData: PaymentMethod }) {
  }
}

export class SetPaymentMethod {
  static readonly type = ActionTypes.SET_PAYMENT_METHOD;

  constructor(public payload: any) {
  }
}

export class GetPaymentIntent {
  static readonly type = ActionTypes.GET_PAYMENT_INTENT;

  constructor(public payload: any) {
  }
}

export class PayInvoice {
  static readonly type = ActionTypes.PAY_INVOICE;

  constructor(public payload: any) {
  }
}

export class DeleteInvoice {
  static readonly type = ActionTypes.DELETE_INVOICE;

  constructor(public payload: any) {
  }
}

export class DeleteInvoiceItem {
  static readonly type = ActionTypes.DELETE_INVOICE_ITEM;

  constructor(public payload: any) {
  }
}

export class DeletePaymentMethod {
  static readonly type = ActionTypes.DELETE_PAYMENT_METHOD;

  constructor(public payload: any) {
  }
}

export class GetPaymentMethods {
  static readonly type = ActionTypes.GET_PAYMENT_METHODS;
}

export class GetStripeBilling {
  static readonly type = ActionTypes.GET_STRIPE_BILLING;
}

export class GetInvoices {
  static readonly type = ActionTypes.GET_INVOICES;
}
